import { render, staticRenderFns } from "./Top3.vue?vue&type=template&id=3490a5aa&scoped=true"
import script from "./Top3.vue?vue&type=script&lang=js"
export * from "./Top3.vue?vue&type=script&lang=js"
import style0 from "./Top3.vue?vue&type=style&index=0&id=3490a5aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3490a5aa",
  null
  
)

export default component.exports